export enum ActionTypes {
    SET_EMPLOYEES_LIST = 'setEmployeesList',
    SET_EMPLOYEES_LIST_FROM_ARRAY = 'setEmployeesListFromArray',
    SET_EMPLOYEES_LIST_FILTER = "setEmployeesListFilter",
    SET_EMPLOYEES_EMPLOYEE_CHANGE_STATUS = "setEmployeesEmployeeChangeStatus",
    SET_EMPLOYEES_EMPLOYEE_DELETE= "setEmployeesEmployeeDelete",
    SET_EMPLOYEES_EMPLOYEE_CREATE= "setEmployeesEmployeeCreate",
    SET_EMPLOYEES_EMPLOYEE_EDIT = "setEmployeesEmployeeEdit",
    SET_EMPLOYEES_SELECTED_EMPLOYEE = "setEmployeesSelectedEmployee",
    SET_EMPLOYEES_TRANSFER_COMPANY_OWNERSHIP = "setEmployeesTransferCompanyOwnership",
    SET_EMPLOYEES_SELECTED_EMPLOYEE_CLEAR = "setEmployeesSelectedEmployeeClear",
    SET_EMPLOYEES_ERROR_MESSAGE_CLEAR = "setEmployeesErrorMessageClear",
    SET_EMPLOYEES_EMPLOYEE_CHANGE_PASSWORD = "setEmployeesEmployeeChangePassword",
}